import React from "react";
import * as hz from "./humanize";
import Box from "@mui/material/Box";

export const toInlineBatsuMark = (
    displayVal?: any,
    okng?: number,
    suffix?: string
): JSX.Element => {
    const mark = okng ? "❌" : "";
    const _suffix = suffix ? suffix : "";
    return (
        <Box
            sx={{
                display: "flex",
                float: "right",
                alignItems: "baseline",
            }}
        >
            <Box sx={{ display: "inline-block", width: "15px", m: 1 }}>
                {mark}
            </Box>
            <Box
                sx={{
                    minWidth: "25px",
                    p: 1,
                }}
            >
                {displayVal}{" "}
            </Box>
            <Box>{_suffix}</Box>
        </Box>
    );
};

export const convertShiftDateToJpn = (
    date?: string,
    usesTime = false
): string => {
    if (!date) {
        return "";
    }
    const _d = date.split("-");
    if (usesTime) {
        const _dd = _d[2].split(" ");
        return `${_d[0]}年${_d[1]}月${_dd[0]}日 ${_dd[1]}`;
    }
    return `${_d[0]}年${_d[1]}月${_d[2]}日`;
};

export const convertUTCtoJST = (date?: string): string => {
    if (!date || date == "" || date == " ") {
        return "";
    }
    const formatted = hz.tsToFormattedTime(date);
    return formatted;
};

export const convertBoardingType = (boardingType?: string | null): string => {
    switch (boardingType) {
        case "go":
            return "GO";
        case "cruising":
            return "流し";
        case "stand":
            return "乗り場";
        case "tel":
            return "無線";
        case "user_cancel":
            return "GOユーザーキャンセル";
        case "driver_cancel_after_acceptance":
            return "GO乗務員承諾後キャンセル";
        case "cancel_tel":
            return "無線他キャンセル";
        case "homing":
            return "帰庫";
        default:
            return "";
    }
};

export const timeStampWithPossibleEnd = (
    time_st: string,
    time_end?: string
): string => {
    if (!time_end) {
        return time_st;
    }
    return `${time_st} - ${time_end}`;
};

export const secToMin = (sec: number): number => {
    return Math.floor(sec / 60);
};

export const secToMinAndSec = (sec: number): string => {
    const mins = Math.floor(sec / 60);
    const secs = sec % 60;
    return `${mins}分${secs}秒`;
};

export const formatDate = (date: string): string => {
    return date.split("-").join("");
};
